import http from "../http-common";

class FunctionDataService {
  getAll() {
    return http.get(`/functions`);
  }

  getAllByProject(projectId) {
    return http.get(`/functions/project/${projectId}`);
  }

  get(id) {
    return http.get(`/functions/${id}`);
  }

  create(data) {
    return http.post("/functions", data);
  }

  update(id, data) {
    return http.put(`/functions/${id}`, data);
  }

  delete(id) {
    return http.delete(`/functions/${id}`,);
  }

  deleteAll() {
    return http.delete(`/functions`, );
  }
}

export default new FunctionDataService();